import * as Yup from 'yup';

export function validationSchema(intl) {
  return Yup.object().shape({
    delayOrder: Yup.boolean(),
    hoursDelay: Yup.number().when('delayOrder', (delayOrder, schema) => {
      if (delayOrder[0] === true) {
        return schema.required(
          intl.formatMessage({
            id: 'controlpanel.form.validation.required'
          })
        );
      }
      return schema.nullable();
    })
  });
}
